/**
 * Models results from importing key images.
 */
export default class MoneroKeyImageImportResult {
    constructor(result) {
        Object.assign(this, result);
        if (this.spentAmount !== undefined && typeof this.spentAmount !== "bigint")
            this.spentAmount = BigInt(this.spentAmount);
        if (this.unspentAmount !== undefined && typeof this.unspentAmount !== "bigint")
            this.unspentAmount = BigInt(this.unspentAmount);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (this.getSpentAmount() !== undefined)
            json.spentAmount = this.getSpentAmount().toString();
        if (this.getUnspentAmount() !== undefined)
            json.unspentAmount = this.getUnspentAmount().toString();
        return json;
    }
    getHeight() {
        return this.height;
    }
    setHeight(height) {
        this.height = height;
        return this;
    }
    getSpentAmount() {
        return this.spentAmount;
    }
    setSpentAmount(spentAmount) {
        this.spentAmount = spentAmount;
        return this;
    }
    getUnspentAmount() {
        return this.unspentAmount;
    }
    setUnspentAmount(unspentAmount) {
        this.unspentAmount = unspentAmount;
        return this;
    }
}
